import {
    $, addAction, INIT, LAYOUT,
} from '@situation/setdesign.util';
import { BREAKPOINTS } from '../shared/theme-globals';

addAction(INIT, () => {
    const baseClass = 'action-buttons';
    const smClass = `${baseClass}--sm`;
    const mdClass = `${baseClass}--md`;
    const $container = $(`.${baseClass}`);
    if (!$container.length) {
        return;
    }

    const calculate = (update) => {
        if (!update) {
            return;
        }

        $container.each((_index, element) => {
            const $item = $(element);
            const width = $item.width();
            let current = width > 420 ? mdClass : smClass;
            current = width > BREAKPOINTS.md ? '' : current;
            $item.removeClass([smClass, mdClass].join(' ')).addClass(current);
        });
    };

    addAction(LAYOUT, calculate);
});
